<template>
    <div class="page" :style="{'--styleColor': actInfo.color, backgroundImage:'url('+ actInfo.bg_other +')'}">
      <PageLoading v-if="loading"></PageLoading>
      <TipsWechat ref="child" v-if="platform==2"></TipsWechat>
      <TipsZonglan ref="child" v-if="platform==3"></TipsZonglan>
      <TipsHbrb ref="child" v-if="platform==4"></TipsHbrb>
      <div class="mainBox">
        <div class="groupTabsBox" v-if="groups.length > 0">
          <van-tabs ref="groupTabs" v-model="activeGid" @change="onGroupChange" class="groupTabs" :color="actInfo.color" :title-active-color="actInfo.color" :ellipsis="false">
            <van-tab :name="0">
              <template #title><span class="tabTitle">全部内容</span></template>
            </van-tab>
            <van-tab v-for="g in groups" :key="g.gid" :name="g.gid">
              <template #title><span class="tabTitle">{{ g.gname }}</span></template>
            </van-tab>
          </van-tabs>
          <i class="huodong icon-gengduo1 moreIcon" v-show="showMoreIcon"></i>
        </div>
        <div class="typeBox" v-else><i class="huodong icon-shiwu-shu"></i>全部内容</div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loadingList" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="(item,index) in list" :key="index" >

                <div class="lessBox" @click="toShow(item.lessionid)">
                   <img class="thumb" :src="item.thumb" alt="">
                   <div class="info">
                      <div class="title">{{item.title}}</div>
                      <div class="status no" v-show="getStatus(item.lessionid)==0"><i class="huodong icon-dingdan2"></i>{{ statusLabel(0) }}</div>
                      <div class="status yes" v-show="getStatus(item.lessionid)==1"><i class="huodong icon-dingdan2"></i>{{ statusLabel(1) }}</div>                      
                      <div class="status ing" v-show="getStatus(item.lessionid)==2"><i class="huodong icon-dingdan2"></i>{{ statusLabel(2) }}</div>
                   </div>
                  </div>

            </van-cell>
          </van-list>
        </van-pull-refresh>
      </div>
      <NavBox :actInfo="actInfo"></NavBox>
      <LotteryBox v-if="actInfo.dis_btn && (actInfo.dis_btn.includes('cj'))" :lotteryid="Number(actInfo.bind_lotteryid)"></LotteryBox>
      <stat :actId="Number(learnid)" :actTitle="actInfo.title" :platform="Number(platform)" v-if="learnid"></stat>
    </div>
</template>

<script>
import { reqLessionList} from '@/api/index2.js'

import PageLoading from '@/components/PageLoading.vue'
import LotteryBox from '@/components/LotteryBox.vue'
import NavBox from '@/components/NavBox.vue'
import TipsWechat from '@/components/TipsWechat.vue'
import TipsZonglan from '@/components/TipsZonglan.vue'
import TipsHbrb from '@/components/TipsHbrb.vue'
import stat from '@/components/stat.vue'
//分享设置
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import Cookies from 'js-cookie'
export default {
  name: 'learnList',
  mixins: [],
  components: { PageLoading, TipsWechat, TipsZonglan, TipsHbrb, LotteryBox, NavBox, stat },
  props: {},
  data () {
    return {
      platform:0, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
      loading:false,
      learnid:0,
      listType:'1', // 课程类型：1视频学习 2图文学习
      actInfo:"",
      token:"",
      list: [],
      groups: [],
      activeGid: 0,
      showMoreIcon: false,
      currPage:1,
      loadingList: false,
      finished: false,
      refreshing: false,
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      style:{},
    }
  },
  computed: {},
  watch: {},
  created () {
    this.platform = this.$route.query.platform;
    this.learnid = this.$route.query.learnid;    
    this.listType = this.$route.query.type || '1';
    this.openid = this.$store.state.openid;
    this.accessid = this.$store.state.accessid;
    this.accountId = this.$store.state.accountId;
    this.uniqueId = this.$store.state.uniqueId;
    this.token = this.$store.state.token;
    this.shareImg = this.$store.state.actInfo.share_img;
    this.shareTitle = this.$store.state.actInfo.share_title;
    this.shareDesc = this.$store.state.actInfo.share_desc;
    this.actInfo = this.$store.state.actInfo;
    const groups = this.$store.state.groups;
    // 仅显示当前课程类型对应的分组（1视频 2图文）
    const type = Number(this.listType);
    this.groups = (Array.isArray(groups) ? groups : []).filter(g => Number(g.type || 1) === type);
  },
  mounted() {
    //分享设置
    wxShare({
      title: this.actInfo.share_title,
      desc: this.actInfo.share_desc,
      img: this.actInfo.share_logo,
      shareUrl: this.actInfo.share_url,
      unShare: this.actInfo.unshare
    })

    this.$nextTick(() => {
      this.bindGroupTabs();
      window.addEventListener('resize', this.updateMoreIcon);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMoreIcon);
    if (this.tabNav) {
      this.tabNav.removeEventListener('scroll', this.onTabNavScroll);
    }
  },
  methods: {
    toShow(lessionid){
      this.$router.push({ path: '/show',query:{...this.$route.query,id:lessionid, platform:this.platform, type:this.listType} })
    },
    onGroupChange(name){
      this.activeGid = name;
      // 切换分组：重置列表并从第1页重新加载
      this.list = [];
      this.currPage = 1;
      this.finished = false;
      this.loadingList = true;
      this.getList();
    },
    bindGroupTabs(){
      const tabs = this.$refs.groupTabs;
      const nav = tabs && tabs.$refs && tabs.$refs.nav;
      if(!nav){
        return;
      }
      this.tabNav = nav;
      nav.addEventListener('scroll', this.onTabNavScroll);
      this.updateMoreIcon();
    },
    onTabNavScroll(){
      this.updateMoreIcon();
    },
    updateMoreIcon(){
      const nav = this.tabNav;
      if(!nav){
        this.showMoreIcon = false;
        return;
      }
      // 内容是否溢出（可横向滚动）
      if(nav.scrollWidth <= nav.clientWidth + 1){
        this.showMoreIcon = false;
        return;
      }
      // 是否已滚动到最右侧
      const atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 1;
      this.showMoreIcon = !atEnd;
    },
    onLoad() {
      console.log('onLoad');
        if (this.refreshing) {
          console.log("刷新");
          this.list = [];
          this.refreshing = false;
          this.currPage = 1;
        }
        this.getList();        
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loadingList = true;
      this.onLoad();
    },
    getList() {
      let data = {
          platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
          learnid:this.learnid, 
          page:this.currPage,
          gid:this.activeGid,
          type:this.listType
      }      
      if(this.platform == 2){               
          data.accessid = this.accessid;
          data.openid = this.openid;
      }
      if(this.platform == 3 || this.platform == 4){
          data.account_id = this.accountId;
          data.unique_id = this.uniqueId;
      }  

      reqLessionList(data).then(res => {        
        this.loading = false;
        // 静态 JSON 不存在（如空分组尚未生成）时按空列表处理
        if(!res){
          this.finished = true;
          this.loadingList = false;
          return;
        }
        if(res.code==200) {       
          if(res.data.list.length < 1) {
            this.finished = true; //全部数据加载完毕
            this.loadingList = false;
          } else {
            this.list.push(...res.data.list);
            if(res.currPage==res.totalPage){
              this.finished = true; //全部数据加载完毕
            }else{
              this.currPage = this.currPage + 1;
            }
            this.loadingList = false; //当前下拉加载完毕
          }   
        } else {
          this.loadingList = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        console.log('err',err);
      }) 
    },
    getStatus(lessionid){
      let watchStatus = false;
      let playCookie = Cookies.get('ckplayer-player-cookie');
      if(typeof playCookie == "undefined" || playCookie===null){
        console.log('playCookie null');
      } else {
        watchStatus = false;
        watchStatus = playCookie.split(/,|;/).includes('lession_'+lessionid);
      }

      let viewed = localStorage.getItem(this.learnid+'_viewed');
      let status = false;
      if(typeof viewed == "undefined" || viewed===null){
        status = false;
      } else {
        status = viewed.split(',').includes(String(lessionid));
      }
      
      if(status){
        return 1; //已观看
      } else if (watchStatus) {
        return 2; //正在观看  
      } else {
        return 0; //未观看
      }
    },
    // 状态文案：视频=观看，图文=阅读
    statusLabel(status){
      const labels = Number(this.listType) === 2
        ? ['未阅读', '已阅读', '阅读中']
        : ['未观看', '已观看', '观看中'];
      return labels[status];
    }
  },
  
}
</script>
<style lang="scss" scoped>
.page{
  width: 750px;
  min-height: 1366px;
  font-size: 30px;
  background-repeat: no-repeat;
  background-size: contain;
  .mainBox{
    width: 700px;
    min-height:400px;    
    position: absolute;
    left: 50%; transform: translateX(-50%);
    top: 150px;        
    background: #fff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding-top: 0px;
    padding-bottom: 100px;
    .typeBox{
      width: 660px;
      margin:20px;
      margin-bottom: 0px;
      padding-bottom: 20px;
      padding-top:10px;
      height: 30px;
      line-height: 30px;
      font-size: 30px;
      font-family: "黑体";
      color:#4c4c4c;
      border-bottom: 2px solid #ccc;
      i{
        font-size: 30px; 
        color: #4c4c4c;
        margin-right: 10px;
      }
    }
    .groupTabsBox{
      position: relative;
      .moreIcon{
        position: absolute;
        right: -5px;
        top: 50%;
        transform: translateY(-50%);
        padding: 0 5px 0 20px;
        background: linear-gradient(to right, rgba(255,255,255,0), #fff 45%);
        pointer-events: none;
        font-size: 30px;
        color: #4c4c4c;
        z-index: 2;
      }
      .tabTitle{
        display: flex;
        align-items: center;
      }
    }
    .lessBox{
      width: 100%;
      height: auto;
      color:#4c4c4c;
      display: flex;
      justify-content: space-between;
      .thumb{
        width: 256px;
        height: 160px;
        display: block;
        border-radius: 8px;
      }
      .info{
        width: 380px;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        .title{ 
          width: 100%;
          height: auto;
        }
        .status{
          width: 140px;
          height: 40px;
          line-height: 40px;
          border-radius: 10px;
          text-align: left;
          padding:0px 10px;      
          i{ font-size: 30px; margin-right: 3px;}   
        }
        .no{
          color: #f74434;
        }
        .yes{
          color: #009b21;
        }
        .ing{
          color: orange;
        }
      }
    }
  }
  :deep(.van-cell){ padding:22px;}
  :deep(.van-cell::after){ border-bottom:4px solid #dbdbdb;}
  :deep(.van-pull-refresh){ border-top-left-radius: 0.26667rem; border-top-right-radius: 0.26667rem;}
}
</style>
